import { render } from "./IndexView.vue?vue&type=template&id=a57a056c"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__